import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import iView from "iview";
import "iview/dist/styles/iview.css";
import "./assets/my-theme/index.less";
import "element-ui/lib/theme-chalk/index.css";
import VueI18n from "vue-i18n";

import "wowjs/css/libs/animate.css"; //wow依赖animate.css
import "wowjs/dist/wow"; //引入wow

import "./util/detector";
import { localeNames, locale } from "./assets/i18n/locale";
import Cookies from "js-cookie";
import http from "@/api/http";
import * as utils from "@/util"; // 全局vue utils方法(在模板{{ }}使用)

import CustomizeComponents from "./components";
// test ci
// import "../src/assets/css/reset.css";//重置样式、文章代码高亮主题
// import "../src/assets/css/ui.css";// 改变某些elementui原有样式

// 按需引用element
import {
  Dialog,
  Collapse,
  CollapseItem,
  Button,
  Loading,
  Select,
  Option,
} from "element-ui";
import "./theme/element-variables.scss";

//使用iview
Vue.use(iView);
//使用element
Vue.use(Button);
Vue.use(Dialog);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Loading);
Vue.use(Select);
Vue.use(Option);

Vue.use(router);
// Vue.use(Divider)

//插件
Vue.use(CustomizeComponents);
Vue.use(VueI18n); //i18n国际化
Vue.use(http); //http请求

//注册全局的utils
Object.keys(utils).forEach((key) => {
  Vue.filter(key, utils[key]);
});

Object.keys(locale).forEach((key) => {
  if (localeNames.length > 0) {
    for (let file of localeNames) {
      try {
        let localFile = require("@/assets/i18n/" + file + ".js");
        Object.assign(locale[key], localFile.default[key]);
      } catch (e) {
        console.error("load " + file + " failed,file was does not exists");
      }
    }
  }
});

/**
 * 获取url参数
 * @param key
 * @returns {*}
 */
function getQueryString(key) {
  let after = window.location.search;
  // if (after.indexOf('?') === -1) return null; //如果url中没有传参直接返回空
  //key存在先通过search取值如果取不到就通过hash来取
  after = after.substr(1) || window.location.hash.split("?")[1];

  if (after) {
    const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
    const r = after.match(reg);
    if (r != null) {
      return decodeURIComponent(r[2]);
    } else {
      return null;
    }
  }
}

// 语言优先级判断
let browserLan = navigator.language === "en" ? "en-US" : "zh-CN"; //先取一下浏览器的language
let language =
  Cookies.get("language") === undefined ? browserLan : Cookies.get("language"); //没有cookie取浏览器的
if (getQueryString("language") !== null) {
  language = getQueryString("language") === "cn" ? "zh-CN" : "en-US";
}

//默认语言的设置
const i18n = new VueI18n({
  locale: language, // 通过改变此处来控制页面语言显示
  messages: locale,
});
Cookies.set("language", language);
Vue.config.lang = language;

new Vue({
  el: "#app",
  router,
  store,
  i18n,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js